import dayjs from 'dayjs';

export function getFormattedDate(dateStr) {
    var date = new Date(dateStr);
    const value = dayjs(date).format('MM-DD-YYYY hh:mm a');
    return value;
}